export default "__VITE_ASSET__BsJ3b8v6__"